/** Function that processes a `facet` input into what's expected by the API.
 *
 * @example
 * ```typescript
 * makeFacetsForQuery([
 *   ['provider_id', 'location_id', 'purpose'],
 *   ['location_id', 'purpose']
 * ]);
 * // Produces the following array:
 * // ['provider_id#location_id#purpose', 'location_id#purpose']
 * ```
 */
export function makeFacetsForQuery(facets) {
    const result = [];
    facets.forEach((facet) => {
        result.push(facet.join('#'));
    });
    return result;
}
//# sourceMappingURL=facet.js.map